
import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Restaurant} from "../../shared/model/restaurant";
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";
import {PayeeCustomer} from "../../shared/model/payee_customer";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {Source} from "../../shared/model/source";
import {Invoice} from "../../shared/model/invoice";
import {CurrencyPipe, DatePipe} from "@angular/common";
import {Plan} from "../../shared/model/plan";
import {StripeSubs} from "../../shared/model/stripe-subs";

@Component({
  selector: 'restaurant-subscription',
  templateUrl: './restaurant-subscription.component.html',
  styleUrls: ['./restaurant-subscription.component.css'],
  // template: `<ng2-smart-table [settings]="settings"></ng2-smart-table>`
})
export class RestaurantSubscriptionComponent implements OnInit {

  private restaurant      : Restaurant;
  private upcomingInvoice : Invoice;
  private billInfo        : PayeeCustomer;
  private plan            : Plan;
  private subscription    : StripeSubs;


  // ******     trial     **********
  private trialStart      : string;
  private trialEnd        : string;

  // ****** upcoming invoice  **********
   upcomingDate    : string;
   upcommingBalance: string;

  // ****** current customer **********
   currentBalance  : string;
  private customerId      : string;

  // ******     card       **********
  private theCard         : string;
   payeeEmail      : string;

  // ****** subscription  **********
   periodEnd       : string;
   periodStart     : string;
  private subscriptionid: string;

  // ******      plan     **********
   planPrice       : string;
   planName        : string;
   planInterval    : string;

  // ******   restaurant  **********
  private restaurantName  : string;
  private restaurantId    : string;


  // ******   Status Flags *********
  private noPaymentSource : boolean;
   noSources       : boolean;
   deliquent       : boolean;
   onTrial         : boolean;
   canceled        : boolean;




  @Input()
  initialValues:any;



  constructor(
    private router:Router,
    private datePipe: DatePipe,
    private currencyPipe:CurrencyPipe,
    private route: ActivatedRoute,
    private stripeService:LocalStripeService,
    public modal: Modal,
    overlay: Overlay,
      vcRef: ViewContainerRef,


  ) {

    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
          this.restaurantId = this.restaurant.$key;
          this.getSourceData();
        }
      )


  }


  ngOnInit() {

    this.restaurantName = this.initialValues.restaurant;

    /*
    this.deliquent = this.accountIsDelilquent();
    console.log("Account delinquent :" + this.deliquent);
*/

  }


  cancel() {
    let navigateTo = '/restaurants/'+ this.restaurant.$key;
    this.router.navigate([navigateTo])
  }


  getSourceData(){

    this.noPaymentSource = true;

    this.stripeService.getBillingInfo(this.restaurantId)
      .subscribe( billInfo => {
       // console.log("getting billing info !");
       // console.log(billInfo);
      this.billInfo = billInfo;
      this.setCurrentBalance();
      this.getCurrentSource(this.billInfo.id);
      this.getUpcomingInvoice(this.billInfo.id);
      this.getSubscription(this.billInfo.id);
    });
  }

  private getSubscription(id: string) {

    this.stripeService.getSubscription(id).subscribe( subscription => {
      this.subscription = subscription;
      this.plan = subscription.plan;
      this.setSubscription();
    });

  }

  private getCurrentSource(billInfoId:string){
    this.stripeService.getSources(billInfoId).subscribe( stripeSource => {
      this.noSources = stripeSource.length == 0;
       // console.log(this.noSources);
       if (!this.noSources){
         let source = Source.fromJson(stripeSource[0]);
         this.theCard = source.card.brand
           + "  **** **** **** "
           + source.card.last4
           + " Exp. "
           + source.card.exp_month
           + "/"
           + source.card.exp_year;

       } else {
         this.theCard = "No Card on file";
       }

    });
  }

  private getUpcomingInvoice(billInfoId:string){

    this.stripeService.getUpcomingInvoice(billInfoId)
      .subscribe( upInvoice => {
          this.upcomingInvoice = upInvoice;
          this.setUpcomingInvoice();
          // console.log("Invoice 162");
          // console.log(upInvoice)
        }
      );
  }

  private setSubscription(){
    this.planName = this.plan.name;
    this.planPrice = this.formatCurrency(this.plan.amount,this.plan.currency);
    this.planInterval = this.plan.interval_count + ' ' + this.plan.interval;

    // console.log(this.subscription);
    // console.log(this.planName + ' ' + this.planPrice + ' ' + this.planInterval);

    this.onTrial = this.subscription.status == "trialing";
    this.trialStart = this.formattDate(this.subscription.trial_start);
    this.trialEnd = this.formattDate(this.subscription.trial_end);
    this.periodStart = this.formattDate(this.subscription.current_period_start);
    this.periodEnd = this.formattDate(this.subscription.current_period_end);
    this.canceled = this.subscription.cancel_at_period_end;
    this.subscriptionid = this.subscription.$key;


  }

  private setCurrentBalance() {
    // console.log(this.billInfo);
    this.currentBalance = this.formatCurrency(this.billInfo.account_balance,this.billInfo.currency);
    this.payeeEmail = this.billInfo.email;
    this.customerId = this.billInfo.id;
    this.deliquent = this.billInfo.delinquent;
  }

  private setUpcomingInvoice(){
    this.upcommingBalance = this.formatCurrency(this.upcomingInvoice.amount_due,this.upcomingInvoice.currency);
    this.upcomingDate = this.formattDate(this.upcomingInvoice.date);
  }


  formattDate(dt){
    // dateFormat(ret, "dddd, mmmm dS, yyyy, h:MM:ss TT");
    let ret = this.datePipe.transform(new Date(dt * 1000), 'yMMMd');
    // ret = {{ret | date: 'dd/MM/yyyy H:mm' }}
    return ret
  }


  formatCurrency(amt,symb){
    // console.log(symb);
    let symbStr = symb.toString().toUpperCase();
    let ret = this.currencyPipe.transform(amt/100, symb, true)
    // TODO : URGENt Before Production Make currency Dynamic
    return ret
  }

  editCard(){

    let navigateRoute = './restaurants/'+ this.restaurantId;

    navigateRoute = navigateRoute +'/editCC';

    this.router.navigate([navigateRoute]);

  }


  editEmail(){

    let navigateRoute = './restaurants/'+ this.restaurantId;

    navigateRoute = navigateRoute +'/editInvEml/'+this.customerId;

    this.router.navigate([navigateRoute]);

  }


  accountIsDelilquent():boolean{
    return true
  }


/*
  setupSubsDisplay(){
    this.currencySymb   = 'US';
    this.currentBalance = this.payeeCust.account_balance;
    this.periodBegin    = new Date(this.payeeSubs.current_period_start * 1000);
    this.periodEnd      = new Date(this.payeeSubs.current_period_end * 1000);
    this.deliquent      = this.payeeCust.delinquent;
    this.onTrial        = true;
    this.trialStart     = new Date(this.payeeSubs.trial_start * 1000);
    this.trialEnd       = new Date(this.payeeSubs.trial_end * 1000);
    this.periodEnd      = new Date(this.payeeSubs.current_period_end * 1000);
    this.payeeEmail     = this.payeeCust.email;



    // console.log("Current Balance: " + this.currentBalance);


  }
*/

  navigateToInvoiceHistory(){

    let navigateRoute = './restaurants/'+ this.restaurantId;

    navigateRoute = navigateRoute +'/invHist';

    this.router.navigate([navigateRoute]);

  }

  createCretiCard(){

    let navigateRoute = './restaurants/'+ this.restaurantId;

    navigateRoute = navigateRoute +'/addCC';

    this.router.navigate([navigateRoute]);

  }


  sendMessage(){
    let navigateRoute = './restaurants/'+ this.restaurantId;

    navigateRoute = navigateRoute +'/emailUs';

    this.router.navigate([navigateRoute]);

  }


  messageIt(titleP:string,messageP:string){
    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }


  restoreSubscription(){
    this.modal.confirm()
      .size('lg')
      .showClose(true)
      .title('Press OK to stop canceling your subscription' )
      .body('Your request to cancel your subscription will be cancel! ')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => { return dialog.result })
      .then((result: any) => { this.restoreSubs() })
      .catch((err: any) => this._cleanup());

  }

  cancelSubscription(){
    this.modal.confirm()
      .size('lg')
      .showClose(true)
      .title('Press OK to cancel your subscription at the end of the current period' )
      .body('No prorated refund wil be issue your subscription will be cancel on ' +this.periodEnd + '<br> please review the terms of services at the end of the page')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => { return dialog.result })
      .then((result: any) => { this.cancelSubs() })
      .catch((err: any) => this._cleanup());

  }


  private restoreSubs() {
    const restSubs$ = this.stripeService.restoreCustomerSubscription(this.subscriptionid);
    restSubs$.subscribe( () => {
      this.messageIt("Subscription Restored","Your subscription will be restored!");
      // console.log("Subscription canceled");
    });

  }


  private cancelSubs() {
    const subsDel$ = this.stripeService.cancelCustomerSubscription(this.subscriptionid);
    subsDel$.subscribe( () => {
      this.messageIt("Subscription Canceled","Your subscription will be canceled!");
      // console.log("Subscription canceled");
    });


  }


  _cleanup(){
  }


  customAlert(){

    // console.log('Editing Email');

    this.modal.prompt()
      .size("lg")
      .showClose(true)
      .title('Change Payee Alert Email Address')
      .defaultValue(this.payeeEmail)
      .placeholder(this.payeeEmail)
      .open();

  }


  onCustom() {
    alert(`Custom event ${this.customerId}`)
  }


}



// WEBPACK FOOTER //
// ./src/app/restaurant/restaurant-subscription/restaurant-subscription.component.ts